// Smoothly scroll to a section by id. Used to funnel all CTAs to the
// "Download" section on this promotional showcase.
export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const goDownload = () => scrollToSection("download");
